import { getSidebarCustomize } from "../sidebar";
/**
 * Check if the current window is the preview iframe.
 */ function isPreviewScreen() {
    return !getSidebarCustomize(false).panel;
}
export { isPreviewScreen };
